import {useEffect, useRef, useMemo, useState} from 'react'
import {notNull} from '../type'
import {isEmpty, isObjectType, mapToObj} from 'remeda'

export const useMemoDebug = <T>(name: string, fn: () => T, dependencies: any[]) => {
  const prevDepsRef = useRef<any[]>([])
  useEffect(() => {
    const changedDeps = mapToObj(
      dependencies
        .map((dep, index) =>
          dep !== prevDepsRef.current[index] ? {index, dep: isObjectType(dep) ? JSON.stringify(dep) : dep} : null
        )
        .filter(notNull),
      ({index, dep}) => [index, {[name]: dep}]
    )
    if (!isEmpty(changedDeps)) {
      // console.log(`${name} useMemo dependencies changed`)
      console.table(changedDeps)
      prevDepsRef.current = dependencies
    }
  }, [dependencies])
  return useMemo(fn, dependencies)
}

/** memos a value based on if SON.stringify is the same */
export const useMemoValue = <T extends object | undefined | null>(value: T): T =>
  useMemo(() => value, [JSON.stringify(value)])

/** memos based on ref equality of each item. usefull for quickly memoing a list that is being filtered */
export const useMemoArray = <T>(items?: T[]) => {
  const previousItemsRef = useRef(items)
  return useMemo(() => {
    const itemsPrev = previousItemsRef.current
    if (items == itemsPrev) return items
    if (items == null || itemsPrev == null) return items
    // Determine if the filtered result has actually changed
    if (items.length !== itemsPrev.length || !items.every((item, index) => item === itemsPrev[index])) {
      previousItemsRef.current = items
      return items
    }
    return itemsPrev
  }, [items])
}
